export const SET_CURRENT_APPLICATION = 'triodos-onboarding/Applications/SET_CURRENT'

export const setCurrentApplication = (id) => ({
  type: SET_CURRENT_APPLICATION,
  payload: id
})
